import { Component, Input, signal, ChangeDetectionStrategy } from '@angular/core';


@Component({
  selector: 'app-image-popup',
  templateUrl: './image-popup.component.html',
  styleUrls: ['./image-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ImagePopupComponent {
  @Input() imageUrl?: string;
  imageLoadError = signal(false);

  close() {
    this.imageUrl = undefined;
    this.imageLoadError.set(false);
  }
}